<template>
	<div class="modify-price">
		<el-dialog title="修改价格" top="4vh" width="1200px" :close-on-click-modal="false" :close-on-press-escape="false"
			:visible.sync="dialogVisible" @close="closeDialog">
			<!-- <el-row type="flex" justify="end">
				<el-button type="success" @click="handleUpload" :loading="loadingUpload">上 传</el-button>
			</el-row> -->
			<el-tabs v-model="tabName" @tab-click="handleTabClick">
				<template v-for="item in listTabs">
					<el-tab-pane :label="item.sku" :name="item.sku">
						<el-form class="custom-form" inline label-width="120px" :label-position="'left'">
							<el-row :gutter="20">
								<!-- 价格 -->
								<el-col :span="8">
									<el-form-item label="价格">
										<el-input type="text" placeholder="请输入"
											v-model="formData.productPrice"></el-input>
									</el-form-item>
								</el-col>
								<!-- 促销价格 -->
								<el-col :span="8">
									<el-form-item label="促销价格">
										<el-input type="text" placeholder="请输入" v-model="formData.sale"></el-input>
									</el-form-item>
								</el-col>
								<!-- 观众 -->
								<el-col :span="8">
									<el-form-item label="观众">
										<el-input type="text" placeholder="请输入" v-model="formData.audience"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<!-- 最低广告价格 -->
								<el-col :span="8">
									<el-form-item label="最低广告价格">
										<el-input type="text" placeholder="请输入" v-model="formData.mapPrice"></el-input>
									</el-form-item>
								</el-col>
								<!-- 卖家允许的最低价格 -->
								<el-col :span="8">
									<el-form-item label="卖家允许最高价格">
										<el-input type="text" placeholder="请输入"
											v-model="formData.maximumSellerPrice"></el-input>
									</el-form-item>
								</el-col>
								<!-- 卖家最低价格 -->
								<el-col :span="8">
									<el-form-item label="卖家允许最低价格">
										<el-input type="text" placeholder="请输入"
											v-model="formData.minimumSellerPrice"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<!-- 促销时间 -->
								<el-col :span="11">
									<el-form-item label="促销日期">
										<el-date-picker v-model="formData.saleTime" unlink-panels size="small"
											type="datetimerange" range-separator="至" start-placeholder="开始日期"
											end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<!-- 价格 -->
								<el-col :span="8">
									<el-form-item label="开始售卖日期">
										<el-date-picker v-model="formData.start_at" unlink-panels size="small"
											type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
											placeholder="开始售卖日期">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<!-- 促销价格 -->
								<el-col :span="8">
									<el-form-item label="结束售卖日期">
										<el-date-picker v-model="formData.end_at" unlink-panels size="small" type="date"
											format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="结束售卖日期">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<!-- 批量设置按钮 -->
								<el-col :span="8">
									<el-form-item>
										<el-button type="primary" @click="setTableVal"
											style="width: 100%;">设置</el-button>
									</el-form-item>
								</el-col>
							</el-row>
							<div v-if="listTabs.length != 1 ? true : false" style="color: red;" class="mT-5">
								注:批量编辑请慎重,切换选项卡后再切换回去则数据会回到初始状态!</div>
						</el-form>
						<!-- 表格部分 -->
						<el-table ref="multipleTable" :data="processedTableData" border lazy>
							<el-table-column prop="sku" label="SKU" align="center" width="300">
								<template slot-scope="scope">
									{{ scope.row.sku }}
								</template>
							</el-table-column>
							<!-- 价格列 -->
							<el-table-column :label="`价格/${countryCurrency}`" align="center" width="120">
								<template slot-scope="scope">
									<el-input v-model="scope.row.productPrice"
										:placeholder="scope.row.productPrice || '请输入价格'"></el-input>
								</template>
							</el-table-column>

							<!-- 促销价格列 -->
							<el-table-column :label="`促销价格/${countryCurrency}`" align="center" width="150">
								<template slot-scope="scope">
									<el-input v-model="scope.row.sale"
										:placeholder="scope.row.sale || '请输入促销价格'"></el-input>
								</template>
							</el-table-column>

							<!-- 促销开始时间 -->
							<el-table-column label="促销开始日期" align="center" width="240">
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.saleTime[0]" type="date" placeholder="请选择促销开始日期"
										format="yyyy-MM-dd" value-format="yyyy-MM-dd">
									</el-date-picker>
								</template>
							</el-table-column>

							<!-- 促销结束时间 -->
							<el-table-column label="促销结束日期" align="center" width="240">
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.saleTime[1]" type="date" placeholder="请选择促销结束日期"
										format="yyyy-MM-dd" value-format="yyyy-MM-dd">
									</el-date-picker>
								</template>
							</el-table-column>

							<!-- 观众列 -->
							<el-table-column label="观众" align="center" width="120">
								<template slot-scope="scope">
									<el-input v-model="scope.row.audience"
										:placeholder="scope.row.audience || '请输入观众'"></el-input>
								</template>
							</el-table-column>

							<!-- 最低广告价格列 -->
							<el-table-column label="最低广告价格" align="center" width="170">
								<template slot-scope="scope">
									<el-input v-model="scope.row.mapPrice"
										:placeholder="scope.row.mapPrice || '请输入最低广告价格'"></el-input>
								</template>
							</el-table-column>

							<!-- 卖家最低价格列 -->
							<el-table-column label="卖家允许的最低价格" align="center" width="220">
								<template slot-scope="scope">
									<el-input v-model="scope.row.minimumSellerPrice"
										:placeholder="scope.row.minimumSellerPrice || '请输入卖家允许的最低价格'"></el-input>
								</template>
							</el-table-column>

							<!-- 卖家允许的最低价格列 -->
							<el-table-column label="卖家允许的最高价格" align="center" width="220">
								<template slot-scope="scope">
									<el-input v-model="scope.row.maximumSellerPrice"
										:placeholder="scope.row.maximumSellerPrice || '请输入卖家允许的最高价格'"></el-input>
								</template>
							</el-table-column>

							<!-- 销售开始时间 -->
							<el-table-column label="开始售卖日期" align="center" width="240">
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.start_at" type="date" placeholder="请选择开始售卖日期"
										format="yyyy-MM-dd" value-format="yyyy-MM-dd">
									</el-date-picker>
								</template>
							</el-table-column>

							<!-- 销售结束时间 -->
							<el-table-column label="结束售卖日期" align="center" width="240">
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.end_at" type="date" placeholder="请选择结束售卖日期"
										format="yyyy-MM-dd" value-format="yyyy-MM-dd">
									</el-date-picker>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</template>
			</el-tabs>
			<div slot="footer">
				<el-button type="primary" @click="updateDataOne()" :loading="loadingUpdate"
					:disabled="listTabs.length > 1 ? true : false">更 新 当 前</el-button>
				<el-button type="primary" @click="updateAllData()" :loading="loadingUpdate"
					:disabled="listTabs.length == 1 ? true : false">更 新 所 有</el-button>
				<el-button type="primary" @click="addItems()" :disabled="listTabs.length == 1 ? true : false">保 存 到 队 列
					中</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
const variantMaps = new Map()

export default {
	name: 'ModifyPrice',

	data() {
		return {
			dialogVisible: false,
			tabName: '',
			listTabs: [],
			shopItem: null,
			loadingUpdate: false,
			loadingUpload: false,
			formData: {
				productPrice: '',
				sale: '',
				saleTime: [],
				minimumSellerPrice: '',
				maximumSellerPrice: '',
				audience: '',
				mapPrice: '',
				start_at: '',
				end_at: ''
			},
			tabIndex: 0, // 当前选中的标签页
			// 默认货币
			countryCurrency: '',
			paramsDataOne: null,
			paramsDataAll: []
		}
	},
	methods: {
		openDialog(list, shopItem) {
			this.shopItem = shopItem
			this.listTabs = JSON.parse(JSON.stringify(list))
			this.tabName = list[0].sku
			this.countryCurrency = list[0].priceCurrency
			this.handleTabClick()
			this.refreshTableLoad()
			this.dialogVisible = true
			this.isUpdate = false
		},
		closeDialog() {
			if (this.isUpdate) {
				this.$emit('close')
			}
		},
		handleTabClick() {
			this.tabIndex = this.listTabs.findIndex(
				(item) => item.sku === this.tabName
			)
			// this.$nextTick(() => {
			// 	const tabItem = this.listTabs[this.tabIndex]
			// 	if (tabItem.amazonOnlineInfoList.length) {
			// 		this.$refs.multipleTable[this.tabIndex].toggleRowExpansion(
			// 			tabItem,
			// 			true
			// 		)
			// 	}
			// })
		},
		async tableLoad(tree, treeNode, resolve) {
			variantMaps.set(tree.id, { tree, treeNode, resolve })
			const variantData = await this.getTableItemVariant(tree)
			resolve(variantData)
		},
		refreshTableLoad() {
			try {
				this.listTabs.forEach((item) => {
					const itemObj = variantMaps.get(item.id)
					if (!itemObj) return
					const { tree, treeNode, resolve } = itemObj
					if (tree) {
						this.tableLoad(tree, treeNode, resolve)
					}
				})
			} catch (e) {
				console.log(e)
			}
		},
		getTableItemVariant(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						data.forEach((item) => {
							item.cusSku = item.childSku
							item.cusImgUrl = item.variantEanImageUrl
							const countryVal =
								item.productPriceObject[tree.areaName]
							item.cusPrice = `${countryVal.value} (${countryVal.currency})`
							item.cusSalePrice = `${item.sale || 0} (${countryVal.currency
								})`
							item.cusProductPrice = `${countryVal.value}`
							item.cusTitle = `${tree.title ||
								''} ${item.childSku || ''}`
							item.isShow = false
							item.saleTime = [
								item.saleBeginTime || '',
								item.saleEndTime || '',
							]
							item.cusStock = item.stock
							item.cusImages = item.imagesList
						})
						this.listTabs[this.tabIndex].children = data
						resolve(data)
					} else {
						reject('400')
					}
				})
			})
		},
		setTableVal() {
			// 批量更新当前表单输入值
			this.processedTableData.forEach(row => {
				// 检查 formData 中每个字段是否有值，如果有值则更新，空值或 null 则跳过
				if (this.formData.productPrice !== undefined && this.formData.productPrice !== null && this.formData.productPrice !== '') {
					row.productPrice = this.formData.productPrice;
				}
				if (this.formData.sale !== undefined && this.formData.sale !== null && this.formData.sale !== '') {
					row.sale = this.formData.sale;
				}
				if (this.formData.saleTime !== undefined && this.formData.saleTime !== null && this.formData.saleTime !== '') {
					row.saleTime = this.formData.saleTime;
				}
				if (this.formData.minimumSellerPrice !== undefined && this.formData.minimumSellerPrice !== null && this.formData.minimumSellerPrice !== '') {
					row.minimumSellerPrice = this.formData.minimumSellerPrice;
				}
				if (this.formData.maximumSellerPrice !== undefined && this.formData.maximumSellerPrice !== null && this.formData.maximumSellerPrice !== '') {
					row.maximumSellerPrice = this.formData.maximumSellerPrice;
				}
				if (this.formData.audience !== undefined && this.formData.audience !== null && this.formData.audience !== '') {
					row.audience = this.formData.audience;
				}
				if (this.formData.mapPrice !== undefined && this.formData.mapPrice !== null && this.formData.mapPrice !== '') {
					row.mapPrice = this.formData.mapPrice;
				}
				if (this.formData.start_at !== undefined && this.formData.start_at !== null && this.formData.start_at !== '') {
					row.start_at = this.formData.start_at;
				}
				if (this.formData.end_at !== undefined && this.formData.end_at !== null && this.formData.end_at !== '') {
					row.end_at = this.formData.end_at;
				}
			});
		},
		handleTableVal(obj) {
			const resultTableVal = {
				product: {
					id: obj.id,
					productPrice: obj.cusProductPrice,
					sale: obj.sale,
					saleBeginTimeStr: obj.saleTime && obj.saleTime[0],
					saleEndTimeStr: obj.saleTime && obj.saleTime[1],
				},
				variantEans: obj.children.map((item) => {
					item.productPriceObject[item.countryMark].value =
						item.cusProductPrice
					const tempObj = {
						id: item.id,
						sale: item.sale,
						productPrice: '',
						saleBeginTimeStr: item.saleTime && item.saleTime[0],
						saleEndTimeStr: item.saleTime && item.saleTime[1],
					}
					if (item.cusProductPrice) {
						tempObj.productPrice = JSON.stringify(
							item.productPriceObject
						)
					}
					return tempObj
				}),
			}
			// 处理数据：没有值，就不穿此key
			const tempObj = resultTableVal.product
			if (!tempObj.productPrice) {
				delete tempObj.productPrice
			}
			if (
				!tempObj.sale &&
				!tempObj.saleBeginTimeStr &&
				!tempObj.saleEndTimeStr
			) {
				delete tempObj.sale
				delete tempObj.saleBeginTimeStr
				delete tempObj.saleEndTimeStr
			}
			if (
				tempObj.sale ||
				tempObj.saleBeginTimeStr ||
				tempObj.saleEndTimeStr
			) {
				if (
					!(
						tempObj.sale &&
						tempObj.saleBeginTimeStr &&
						tempObj.saleEndTimeStr
					)
				) {
					this.$message.warning('请将促销信息补充完整')
					return
				}
			}
			for (let item of resultTableVal.variantEans) {
				if (!item.productPrice) {
					delete item.productPrice
				}
				if (
					!item.sale &&
					!item.saleBeginTimeStr &&
					!item.saleEndTimeStr
				) {
					delete item.sale
					delete item.saleBeginTimeStr
					delete item.saleEndTimeStr
				}
				if (item.sale || item.saleBeginTimeStr || item.saleEndTimeStr) {
					if (
						!(
							item.sale &&
							item.saleBeginTimeStr &&
							item.saleEndTimeStr
						)
					) {
						this.$message.warning('请将促销信息补充完整')
						return
					}
				}
			}
			// 处理数据：如果只有id，就不传值
			if (Object.keys(tempObj).length === 1 && !!tempObj.id) {
				delete resultTableVal.product
			}
			resultTableVal.variantEans = resultTableVal.variantEans.filter(
				(item) => Object.keys(item).length > 1 && !!item.id
			)
			if (!resultTableVal.variantEans.length) {
				delete resultTableVal.variantEans
			}
			return resultTableVal
		},
		submitUpdate(value) {
			let currentTab;
			// 判断 listTabs 是否为空，确保有数据
			if (this.listTabs.length > 0) {
				if (this.listTabs[0]?.purchasable_offer) {
					currentTab = this.listTabs[this.tabIndex];
				} else {
					currentTab = this.listTabs[this.tabIndex + 1] || this.listTabs[this.tabIndex];
				}
			}
			if (!currentTab || !currentTab.amazonOnlineInfoList) {
				this.$message.error("无法提交数据：当前选项卡数据不存在！");
				this.loadingUpdate = false;
				return;
			}
			const requestPayload = {
				listingId: currentTab.listingId,
				rid: JSON.parse(localStorage.getItem('role') || '{}').rid,
				amazonOnlineInfoList: value.map((item, index) => {
					if (index === 0 && !currentTab.purchasable_offer) {
						return { sku: item.sku };
					}
					return {
						sku: item.sku,
						purchasable_offer: item.purchasable_offer,
					};
				}).filter(item => item.sku)
			};
			if (this.listTabs.length == 1) {
				this.paramsDataOne = requestPayload
			} else {
				this.paramsDataAll.push(requestPayload)
			}
		},
		updateDataOne() {
			this.loadingUpdate = true;
			this.updateData()
			let API = Baseurl + 'amazonProductListing/batchModifyOffer'
			ajaxPost(API, [this.paramsDataOne])
				.then((res) => {
					if (res.data.code == 200) {
						this.$message.success("数据已成功提交！");
						this.loadingUpdate = false;
						this.dialogVisible = false;
						this.$parent.$refs.multipleTable.clearSelection();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		addItems() {
			this.updateData().then(() => {
				if ((this.tabIndex + 1) != this.listTabs.length) {
					this.tabIndex += 1;
					this.tabName = this.listTabs[this.tabIndex].sku
					this.handleTabClick()
				} else {
					this.$message.success("加入队列成功,已到最后一个选项卡,请注意更新所有!");
				}
			})
		},
		filterDuplicateSku(arr) {
			const seenSku = new Set();
			const result = [];
			arr.forEach(item => {
				if (item.amazonOnlineInfoList && Array.isArray(item.amazonOnlineInfoList)) {
					const filteredList = item.amazonOnlineInfoList.filter(subItem => {
						if (!seenSku.has(subItem.sku)) {
							seenSku.add(subItem.sku);
							return true;
						}
						return false;
					});
					// 如果存在子数组，递归处理
					if (filteredList.length > 0) {
						item.amazonOnlineInfoList = filteredList;
						result.push(item);
					}
				}
			});
			return result;
		},
		updateAllData() {
			this.loadingUpdate = true;
			this.paramsDataAll = this.filterDuplicateSku(this.paramsDataAll)
			for (let index = 0; index < this.listTabs.length; index++) {
				this.paramsDataAll[index].listingId = this.listTabs[index].listingId
			}
			let API = Baseurl + 'amazonProductListing/batchModifyOffer'
			ajaxPost(API, this.paramsDataAll)
				.then((res) => {
					if (res.data.code == 200) {
						this.$message.success("数据已成功提交！");
						this.loadingUpdate = false;
						this.dialogVisible = false;
						this.$parent.$refs.multipleTable.clearSelection();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		async updateData() {
			const currentTab = this.listTabs[this.tabIndex];
			const currency = currentTab.priceCurrency;
			const marketplaceId = currentTab.marketplaceId;
			const updatedData = this.processedTableData.map((item) => {
				const offer = {};
				// 确保 map_price 处理正确
				if (item.mapPrice && item.mapPrice !== "" && !isNaN(parseFloat(item.mapPrice))) {
					offer.map_price = [
						{
							schedule: [
								{
									value_with_tax: parseFloat(item.mapPrice),
								},
							],
						}
					];
				}
				// 确保 sale 和 our_price 处理正确
				if (item.sale && item.sale !== "" && !isNaN(parseFloat(item.sale))) {
					offer.our_price = [
						{
							schedule: [
								{
									value_with_tax: parseFloat(item.sale) || parseFloat(item.productPrice) || 0,
								},
							],
						},
					];
				}
				const startDate = new Date(item.start_at);
				const endDate = new Date(item.end_at);
				if (!isNaN(startDate)) {
					offer.start_at = { value: item.start_at };
				}
				if (!isNaN(endDate)) {
					offer.end_at = { value: item.end_at };
				}
				// 处理 saleTime，检查 start_at 和 end_at 是否为有效的值
				if (item.saleTime && item.saleTime.length === 2) {
					const [startAt, endAt] = item.saleTime;
					const startDate = new Date(startAt);
					const endDate = new Date(endAt);
					// 确保 startAt 和 endAt 是有效日期
					if (!isNaN(startDate) && !isNaN(endDate)) {
						offer.start_at = { value: startAt };
						offer.end_at = { value: endAt };
						offer.discounted_price = [
							{
								schedule: [
									{
										start_at: startAt,
										end_at: endAt,
										value_with_tax: parseFloat(item.sale) || parseFloat(item.productPrice) || 0,
									},
								],
							}
						];
					}
				}
				// 处理 maximum_seller_allowed_price 和 minimum_seller_allowed_price
				if (item.maximumSellerPrice && item.maximumSellerPrice !== "" && !isNaN(parseFloat(item.maximumSellerPrice))) {
					offer.maximum_seller_allowed_price = [
						{
							schedule: [
								{
									value_with_tax: parseFloat(item.maximumSellerPrice) || 0,
								},
							],
						},
					];
				}
				if (item.minimumSellerPrice && item.minimumSellerPrice !== "" && !isNaN(parseFloat(item.minimumSellerPrice))) {
					offer.minimum_seller_allowed_price = [
						{
							schedule: [
								{
									value_with_tax: parseFloat(item.minimumSellerPrice) || 0,
								},
							],
						},
					];
				}
				offer.audience = item.audience && item.audience !== "" ? item.audience : '';
				offer.currency = currency;
				offer.marketplace_id = marketplaceId;
				if (Object.keys(offer).length > 0) {
					item.purchasable_offer = offer;
				}
				return item;
			});
			// 执行更新提交
			this.submitUpdate(updatedData);
		},
		handleUpload() {
			const API = Baseurl + 'amaoznFeedUpload/saleProductSubmit'
			const paramsData = {
				marketInfo: JSON.stringify({
					sellerId: this.shopItem.sellerId,
					mwsAuthToken: this.shopItem.mwsAuthToken,
					countryMark: this.shopItem.countryMark,
					marketplaceId: this.shopItem.marketPlaceId,
				}),
				ids: this.listTabs.map((item) => item.id),
				type: 4, // （基本信息1  图片3 价格4 库存5）
			}
			// console.log(JSON.parse(JSON.stringify(paramsData)))
			// return
			this.loadingUpload = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpload = false
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success(data)
				}
			})
		},
	},
	computed: {
		// 处理 table 数据
		processedTableData() {
			return this.listTabs[this.tabIndex].amazonOnlineInfoList.map(item => {
				const offer = item.purchasable_offer || {};
				// 安全获取嵌套值
				const getValue = (path) => {
					return path && path[0] && path[0].schedule && path[0].schedule[0] ? path[0].schedule[0].value_with_tax : '';
				};
				// 获取促销时间的开始和结束日期
				const getSaleTime = (discountedPrice) => {
					if (discountedPrice && discountedPrice[0] && discountedPrice[0].schedule) {
						const schedule = discountedPrice[0].schedule[0];
						return [schedule.start_at, schedule.end_at]; // 返回开始和结束时间
					}
					return ['', '']; // 没有促销时返回空字符串
				};
				return {
					...item,
					// 回显价格信息
					productPrice: getValue(offer.our_price),
					// 促销价格，优先显示 discounted_price 的 value_with_tax，如果没有则回显 our_price
					sale: offer.discounted_price ? getValue(offer.discounted_price) : getValue(offer.our_price),
					// 促销时间
					saleTime: getSaleTime(offer.discounted_price), // 获取促销时间
					// 最低卖家价格
					minimumSellerPrice: getValue(offer.minimum_seller_allowed_price),
					// 最高卖家价格
					maximumSellerPrice: getValue(offer.maximum_seller_allowed_price),
					// 观众
					audience: offer.audience || '',
					// 最低广告价格
					mapPrice: getValue(offer.map_price),
					// 开始日期
					start_at: offer.start_at ? offer.start_at.value : '',
					// 结束日期
					end_at: offer.end_at ? offer.end_at.value : ''
				};
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.modify-price {
	::v-deep {
		.custom-form {
			margin: 10px 0;

			.el-form-item {
				margin: 0;
			}
		}
	}
}
</style>
